import React, { useState } from "react";
import { FaChevronDown, FaChevronUp, } from "react-icons/fa";
// import { RiCloseLargeFill } from "react-icons/ri";
import { TiArrowLeftThick } from "react-icons/ti";

import "../../Styles/Employeefilter.css";

function Employeefilter({ show = true, onClose = () => { } }) {

  const [openMenus, setOpenMenus] = useState({});



  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

    onClose(false);
  };
  if (!show) return null;

  return (
    <div className={`admin-sidebar-filter `}>
      <div className="filter-sidebar-header">
        <button className="close-arrow" onClick={() => onClose(false)}>
          <TiArrowLeftThick />
        </button>
        <span className="filter-dashboard-tit">Filter</span>

      </div>

      <ul className="filter-sidebar-menu">


        {/* University/Autonomous */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("contact")}>
            <span>Organization Name</span>
            {openMenus.contact ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.contact ? "open" : ""}`}>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">NHRC Community</spam>
              </div>
            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HR Connect India</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">SmartHire Solutions</spam>
              </div>

            </li>
            <li className="filter-line-bottom">

             
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">RecruitRight India</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
          
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">TalentBridge HR</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* College */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("registration")}
          >
            <span>Industry</span>
            {openMenus.registration ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.registration ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Information Technology</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Manufacturing</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
            
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Education & Training</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Banking & Finance</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Railways</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Designation */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("jobs")}>
            <span>Designation</span>
            {openMenus.jobs ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.jobs ? "open" : ""}`}>
            <li className="filter-line-bottom">
              

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Chief Human Resources Officer</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Vice President-Human Resources</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HR Manager</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HR Business Partner</spam>
              </div>

            </li>

          </ul>
        </li>

        {/* Department */}
        <li>
          <div
            className="filter-menu-item"
            onClick={() => toggleMenu("permission")}>
            <span>Department</span>
            {openMenus.permission ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul
            className={`filter-submenu ${openMenus.permission ? "open" : ""}`}
          >
            <li className="filter-line-bottom">
              
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Human Resource Administration</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HR Planning & Strategy</spam>
              </div>

            </li>

            <li className="filter-line-bottom">
               
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Campus Hiring / Placement Cell</spam>
              </div>

            </li>

            <li className="filter-line-bottom"> 

              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">Student Welfare Department</spam>
              </div>

            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">HR Business Partnering</spam>
              </div>
            </li>
          </ul>
        </li>

        {/* States */}
        <li>
          <div className="filter-menu-item" onClick={() => toggleMenu("services")}>
            <span>Company Strength</span>
            {openMenus.services ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          <ul className={`filter-submenu ${openMenus.services ? "open" : ""}`}>

            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">50-100</spam>
              </div>

            </li>


            <li className="filter-line-bottom">
                <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">100-150</spam>
              </div>
            </li>

            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">150-200</spam>
              </div>
            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">200-250</spam>
              </div>
            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">250-300</spam>
              </div>
            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">300-350</spam>
              </div>
            </li>
            <li className="filter-line-bottom">
              <div className="text-cont">
                <div>
                  <input className="chech-filter" type="checkbox"></input>
                </div>
                <spam className="text-filter">350-400</spam>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default Employeefilter;
